import { Link } from "@tanstack/react-router";
import { EXAMS } from "@/lib/exams";

const LINKS = [
  { to: "/about", label: "About Us" },
  { to: "/privacy", label: "Privacy Policy" },
  { to: "/terms", label: "Terms & Conditions" },
  { to: "/refund", label: "Refund Policy" },
  { to: "/contact", label: "Contact Us" },
] as const;

export function SiteFooter() {
  return (
    <footer className="page-shell mt-12 px-5 lg:px-8 pb-4 text-center">
      <nav aria-label="Exams" className="flex flex-wrap items-center justify-center gap-x-1 gap-y-0.5">
        {EXAMS.map((exam) => (
          <Link
            key={exam.slug}
            to={exam.route}
            className="inline-flex min-h-[44px] items-center px-2 text-[11px] text-muted-foreground transition-colors hover:text-foreground"
          >
            {exam.shortName}
          </Link>
        ))}
      </nav>
      <nav className="flex flex-wrap items-center justify-center gap-x-1 gap-y-0.5">
        {LINKS.map((link) => (
          <Link
            key={link.to}
            to={link.to}
            className="inline-flex min-h-[44px] items-center px-2 text-[11px] text-muted-foreground transition-colors hover:text-foreground"
          >
            {link.label}
          </Link>
        ))}
      </nav>
      <p className="mt-3 text-[11px] text-muted-foreground">
        © 2026 thequantummindsofficial. All Rights Reserved.
      </p>
      <p className="mt-1 text-[11px] text-muted-foreground">
        The Quantum Minds is independently operated by Aryan Singh.
      </p>
    </footer>
  );
}